module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_012.png
// module id = 1136
// module chunks = 0